import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "委託", enum: "ENTRUST" },
  { value: 2, text: "消化仕入", enum: "DIGESTIVE" },
]);
